import Consult from './Consult';
import List from './List';
import Result from './Result';

export default {
  Consult,
  List,
  Result,
};
